import type { ReactNode } from 'react'

import './feedback.css'

/**
 * key/value 2열 — 와이어프레임 `rows()` 1012행. 요약 패널·정보 구역이 쓴다.
 *
 * 🔴 값 텍스트는 전부 같은 크기·굵기다. 굵은 강조를 남발하지 않는다(§1-2).
 * 🔴 열 이름은 한글이다. 스키마 필드명을 그대로 쓰지 않는다(§1-1).
 */
export type ValueRow = {
  key: string
  label: string
  value: ReactNode
  /** `layout="grid"` 에서 **한 줄을 다 쓴다**(두 칸을 합친다). 값이 긴 줄에 준다 */
  wide?: boolean | undefined
}

export type ValueRowsProps = {
  rows: readonly ValueRow[]
  /**
   * `'grid'` — 라벨·값 **쌍**이 두 열로 흐른다(라벨 위 · 값 아래). eric 2026-09-30 작업 상세 「작업」 카드
   * 「여러 줄인데.. 2개의 열로 표현해줘」. 좁은 서랍(1/3)에서 라벨:값을 한 줄에 둘씩 놓으면 값이 접혀서
   * 쌍을 세로로 쌓는다. 안 주면 종전 그대로(한 줄에 라벨:값 하나).
   */
  layout?: 'grid' | undefined
}

export function ValueRows({ rows, layout }: ValueRowsProps) {
  return (
    <dl className={layout === 'grid' ? 'a-rows a-rows--grid' : 'a-rows'}>
      {rows.map((row) => (
        <div
          className={row.wide === true ? 'a-rows__pair a-rows__pair--wide' : 'a-rows__pair'}
          data-key={row.key}
          key={row.key}
        >
          <dt className="a-rows__k">{row.label}</dt>
          <dd className="a-rows__v">{row.value}</dd>
        </div>
      ))}
    </dl>
  )
}
